import React from 'react';

import AppImage from '../AppImage';

import styles from './AppPersonCard.module.scss';

export default function AppPersonCard({ author }) {
  return (
    <div className={styles.AppPersonCard}>
      <div className={styles.AppPersonCard__Avatar}>
        <AppImage src={author?.image?.url} alt={author?.full_name}/>
      </div>
      <div className={styles.AppPersonCard__Info}>
        <strong>{author?.full_name}</strong>
        <span>{author?.position}</span>
      </div>
    </div>
  );
}
